import { Record } from '../transit'

const User = Record({
  _id: '',
  firstName: '',
  lastName: '',
  name: '',
  nameReversed: '',
  email: '',
  role: '',
  company: '',
  archived: false,
  archivedAt: null,
  canCreateAttendance: false,
  tokens: {
    access: '',
  },
}, 'user')

export default User



// WEBPACK FOOTER //
// ./src/common/users/User.js